import React from 'react';

/**
 * Lightweight skeleton shown while a lazy-loaded route chunk is being fetched.
 * Renders instantly (no dependencies, no icons) — meant to avoid perceived
 * blank/frozen state during First Meaningful Paint.
 */
export default function RouteFallback() {
  return (
    <div className="space-y-4 animate-pulse" data-testid="route-fallback">
      <div className="h-8 w-64 bg-slate-200 rounded" />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="h-28 bg-slate-100 rounded-lg" />
        <div className="h-28 bg-slate-100 rounded-lg" />
        <div className="h-28 bg-slate-100 rounded-lg" />
      </div>
      <div className="h-64 bg-slate-100 rounded-lg" />
    </div>
  );
}
